import React from 'react'
import MainHeader from "./partials/newheader";    
import Contact from './Contact';
import Footer from "./partials/footer";

export default function Pettipetticontact() {
  return (
    <div>
      <MainHeader />
      <Contact />
      <Footer />
    </div>
  );
}
